import { createTransport } from '@sentry/react';

export function createLocalTransport(options: Parameters<typeof createTransport>[0]) {
  return createTransport(options, (request) => {
    if (import.meta.env.APP_LOG_SENTRY_EVENTS) {
      const jsonStrings = (request.body as string).trim().split('\n');
      const destructuredBody = jsonStrings.reduce((result, part) => {
        return {
          // biome-ignore lint/performance/noAccumulatingSpread: TODO: improve performance
          ...result,
          ...JSON.parse(part),
        };
      }, {});

      console.info(
        `[SENTRY ${((destructuredBody as { type?: string })?.type || '').toUpperCase()} EVENT]: `,
        destructuredBody,
      );
    }

    return Promise.resolve({
      statusCode: 200,
    });
  });
}
